import { defineStore } from 'pinia'
import { i18n } from '../plugins/i18n'

const STORAGE_KEY = 'diplomatica-locale'
const SUPPORTED = ['en', 'fr']

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    locale: 'en'
  }),

  getters: {
    supportedLocales: () => SUPPORTED
  },

  actions: {
    init() {
      const stored = localStorage.getItem(STORAGE_KEY)
      const browser = navigator.language?.slice(0, 2)
      const initial = SUPPORTED.includes(stored)
        ? stored
        : SUPPORTED.includes(browser) ? browser : 'en'
      this.setLocale(initial)
    },

    setLocale(newLocale) {
      if (!SUPPORTED.includes(newLocale)) return
      this.locale = newLocale
      i18n.global.locale.value = newLocale
      localStorage.setItem(STORAGE_KEY, newLocale)
      document.documentElement.setAttribute('lang', newLocale)
    }
  }
})
